export default {
    name: 'reviewObservationFilter',
    namespaced: true,
    state: {
        filtro: {
            show: false,
            vns_filter: '',
            container_filter: '',            
            patient_filter: ''            
        }
    },
    getters: {
        all (state) {
            return state.filtro
        },
        getSpecific (state, key) {
            return state.filtro[key]
        },
    },
    mutations: {
        setAll (state, obj) {
            state.filtro = obj
        },
        setSpecific (state, obj) {
            state.filtro = {...state.filtro, ...obj}
        },
    },
    actions: {
        setFiltro ({ commit, state }, obj) {
            commit('setAll', obj)
        },
        setSpecific ({ commit, state }, obj) {
            commit('setSpecific', obj)
        },
        reset ({ commit, state }) {
            commit('setSpecific', {
                show: false,                
                vns_filter: '',
                container_filter: '',                
                patient_filter: ''
            })
        },
    }
}
